const sortByPosition = (a, b) => (a?.position ?? 0) - (b?.position ?? 0);

export const resolveLessonVideoUrl = (lesson) => {
  const sources = lesson?.video_source;
  const selectedSource = sources?.find(
    (source) => source?.selected === true || source?.selected === 1,
  );
  const direct = selectedSource?.src || sources?.[0]?.src;
  if (direct) return direct;
  if (lesson?.video_id) return `https://vimeo.com/${lesson.video_id}`;
  return "";
};

export const buildVideoPlaylist = (sections = []) => {
  const lessons = sections
    .slice()
    .sort(sortByPosition)
    .flatMap((section) =>
      (section?.lessons || []).filter((lesson) => lesson?.type === "Video").sort(sortByPosition),
    );

  return lessons.map((lesson) => ({
    id: lesson.id,
    name: lesson.name,
    url: resolveLessonVideoUrl(lesson),
    lesson,
  }));
};

export const findLessonIndex = (playlist = [], lessonId) =>
  playlist.findIndex((item) => String(item.id) === String(lessonId));
